import { useEffect } from 'react';
import { useGlobalContext } from '../../contexts';
//apollo
import client from '../../src/utils/apollo/client';
//queries
import {GET_BLOG_FRONTPAGE} from '../../src/queries/posts/get-blog-frontpage';
//routing
import {handleRedirectsAndReturnData} from '../../src/utils/slug';
//components
import Layout from '../../src/components/layout'

const Blog = ( { data } ) => {
  const { context, setContext } = useGlobalContext();

  useEffect(() => {
    if (!context.isSet) {
      data.context.options.isSet = true;
      setContext(data.context.options);
    }
  }, []);

	return (
    <Layout
      logos={data?.logos?.options?.logos}
      mainMenu={data?.mainMenu?.edges}
      menuFooter={data?.menuFooter?.edges}
      seo={data?.content?.seo}
      breadcrumbs={data?.content?.seo?.breadcrumbs}
      content={data?.content}
      pt_key={process.env.PAGE_PT_KEY}
      templateWhite={data?.content?.acfSidebar?.bgWhite}
      optionsFooter={data?.content?.acfSidebar?.optionsFooter}
      tags={data?.tags}
      posts={data?.posts}
    >
    </Layout>
	);
};

export default Blog;

export async function getStaticProps(context) {
	const { data, errors } = await client.query( {
		query: GET_BLOG_FRONTPAGE(process.env.PAGE_PT_KEY),
		variables: {
		  id: process.env.BLOG_PAGE_ID,
		},
	});

	const defaultProps = {
		props: {
			data: data || {}
		},
		revalidate: 60,
	};

	return handleRedirectsAndReturnData( defaultProps, data, errors, { allowNotFound: false } );
}